import { Route, Redirect } from 'react-router-dom';
import { account } from 'routes.js';

const protectedPaths = account.map((route) => route.layout + route.path);
const redirectToLoginProtectedPaths = ['/account'];

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = localStorage.getItem('auth');

  return (
    <Route
      {...rest}
      render={(props) =>{
        const pathname = props.location.pathname;
        console.log('props', pathname);
        const shouldRedirectToLogin = redirectToLoginProtectedPaths.some(
          (path) => pathname.startsWith(path)
        );
        return protectedPaths.some((path) => pathname.startsWith(path)) && !isAuthenticated ? (
          <Redirect
            to={{
              pathname: shouldRedirectToLogin ? '/auth/login' : '/',
              state: { from: pathname }
            }}
          />
        ) : (
          <Component {...props} />
        );
      }}
    />
  );
};

export default PrivateRoute;
